import useReport from './use-report';
import { useShallowEqualEffect } from '../../../utils/use-shallow-effect';

export type UseReportResultsArgs = {
  id: string;
  params?: object;
  pagination: {
    page: number;
    perPage: number;
    setPage: (page: number) => void;
  };
  sortable: {
    field?: string | null;
    direction?: string | null;
  };
  queryKeyPrefix?: string;
};

const useReportResults = (args: UseReportResultsArgs) => {
  const { id, params, pagination, sortable, queryKeyPrefix } = args;

  const query = useReport({
    page: pagination.page,
    perPage: pagination.perPage,
    sortableField: sortable.field,
    sortableDirection: sortable.direction,
    id,
    params,
    queryKeyPrefix,
  });

  useShallowEqualEffect(() => {
    if (pagination.page !== 1) {
      pagination.setPage(1);
    }
  }, [params]);

  return query;
};

export default useReportResults;
